/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get */
import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
import { action, computed } from '@ember/object';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';

export default class ExpectationsController extends Controller {
  @service
  router;

  @computed('router.currentRouteName')
  get isSingleSubject() {
    return [
      'group.expectations.subject',
      'group.expectations.subject_loading',
    ].includes(this.router.currentRouteName);
  }

  @tracked
  selectedMilestoneSet = null;

  @computed('model.subjects.[]', 'selectedMilestoneSet.{id,isDefault}')
  get subjects() {
    if (isEmpty(this.model) || isEmpty(this.selectedMilestoneSet)) {
      return [];
    }
    let subjects = this.model.subjects;
    if (this.get('selectedMilestoneSet.isDefault')) {
      // Hide any subjects which are using a Milestone Set.
      subjects = subjects.filter((item) => !item.milestone_set_id);
    } else {
      subjects = subjects.filter(
        (item) => item.milestone_set_id === this.get('selectedMilestoneSet.id'),
      );
    }
    return subjects
      .slice()
      .sort(
        (a, b) =>
          a.sequence - b.sequence ||
          (a.label || '').localeCompare(b.label || ''),
      );
  }

  @action
  selectMilestoneSet(milestoneSet) {
    this.selectedMilestoneSet = milestoneSet;
    if (isEmpty(this.subjects)) {
      this.router.transitionTo('group.expectations.index', this.model.group);
    } else {
      this.router.transitionTo(
        'group.expectations.subject',
        this.model.group.id,
        this.subjects[0].id,
      );
    }
  }
}
